var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { map } from 'lodash';
import { ArrayFormat } from './array';

var ArrayEntriesFormat = function (_super) {
  __extends(ArrayEntriesFormat, _super);

  function ArrayEntriesFormat() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 将数据格式化为请求参数
   */


  ArrayEntriesFormat.prototype.formatParams = function (key, value) {
    var _a;

    return _a = {}, _a[key] = map(value, function (item) {
      return {
        id: item.id,
        value: item.value
      };
    }), _a;
  };

  return ArrayEntriesFormat;
}(ArrayFormat);

export { ArrayEntriesFormat };